export enum EquipmentFilterType {
  ORGANISATION = 'equipmentOrganisations',
  ASSIGNED_EMPLOYEE = 'assignedEmployee',
  LABEL = 'customerLabels',
  CLASS = 'equipmentTypes',
  STATUS = 'status',
  TRANSPORT_VEHICLE_ONLY = 'showOnlyTransportVehicles',
  FAVOURITE_ONLY = 'showOnlyFavouriteEquipments',
  WITHOUT_SUBEQUIPMENTS = 'showSubEquipments',
  TRANSPORT_TYPES = 'transportTypes',
  MATCH_ALL_LABELS = 'matchAllLabels',
  ATTENTION_STATUS = 'attentionStatus',
  ACTIVITY_STATUS = 'activityStatus',
  COMPLETENESS_STATUS = 'completenessStatus',
  TRANSPORT_OPTIONS = 'equipmentFilterTransportOptions',
  LAST_SEEN = 'lastSeen',
  MODEL = 'equipmentModels',
  MANUFACTURER = 'equipmentManufacturers',
  CUSTOMER = 'equipmentCustomers',
  CONSTRUCTION_YEAR = 'constructionYears',
}
